import React from 'react';
import Stack from '@mui/material/Stack';
import { BillingModeSelector } from '../IngramHeader/BillingModeSelector/BillingModeSelector';
import { useInX4AFrame } from 'mf_core/config';
import { useShowBillingModeSelector } from '../../hooks/useShowBillingModeSelector';
import { useAddToQuote } from 'mf_shared/AddToQuote';

export const ViewHeader = ({
  billingModeSelectorProps: { showCartIcon },
}: Readonly<{
  billingModeSelectorProps: {
    showCartIcon: boolean;
  };
}>) => {
  const { isInX4AFrame } = useInX4AFrame();
  const showHeader = isInX4AFrame;

  const { showQuoteButton } = useAddToQuote();
  const showQuoteIcon = showCartIcon && showQuoteButton;

  const showBillingModeSelector = useShowBillingModeSelector(showQuoteIcon);

  return showHeader && showBillingModeSelector ? (
    <Stack
      alignItems="center"
      id="view-header"
      justifyContent="start"
      p={0.5}
      width="100%"
    >
      <BillingModeSelector />
    </Stack>
  ) : null;
};
